export default __webpack_public_path__ + "static/media/PrivacyPolicy.af6c152c.md";